import { COMPARE_MODE } from '../../components/pages/reports/consts';
import { SOURCE_FIELD } from '../../utils/reportsConsts';
import { resolveSourceMapping } from './sourceMappingResolver';

export default {
    reports: (dim, adminModeEnabled, reportMode) => {
        return reportMode === COMPARE_MODE ? dim.is_comparison_default : dim.is_default;
    },
    pivot: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    retention: dim => {
        if (dim.actual_type === 'dimensions') {
            return ['app', 'source'].includes(dim.name);
        }
        if (dim.actual_type === 'periods') {
            const dayMatch = /^(\d+)d$/.exec(dim.name);
            return !!dayMatch && Number(dayMatch[1]) <= 30;
        }
        return dim.is_default;
    },
    creatives: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    anonymousReport: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    permissions: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    fraudProtected: (dim, adminModeEnabled, reportMode) => {
        if (dim.type === 'metric' || dim.type === 'dimension') {
            return dim.fraud_protected_default;
        } else {
            return dim.is_default;
        }
    },
    fraudSuspicious: (dim, adminModeEnabled, reportMode) => {
        if (dim.type === 'metric' || dim.type === 'dimension') {
            return dim.fraud_suspicious_default;
        } else {
            return dim.is_default;
        }
    },
    fraudRejected: (dim, adminModeEnabled, reportMode) => {
        if (dim.is_cohort) {
            return false;
        }
        if (dim.type === 'metric' || dim.type === 'dimension' || dim.actual_type === 'periods') {
            return !!dim.fraud_rejected_default;
        } else {
            return dim.is_default;
        }
    },
    adMonetization: (dim, adminModeEnabled) => {
        return dim.is_admon_default;
    },
    crossDevice: (dim, adminModeEnabled, reportMode) => {
        return dim.is_cross_device_default || dim.is_default;
    },
    skan: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    skanSummary: (dim, adminModeEnabled, reportMode) => {
        return dim.is_default;
    },
    unifiedReport: (dim, adminModeEnabled) => {
        return typeof dim.is_unified_report_default === 'boolean' ? dim.is_unified_report_default : dim.is_default;
    },
    creativeExplore: (dim, adminModeEnabled, reportMode, rawSelectedSources) => {
        // resolveSourceMapping below already returns dim.is_default as the fallback for an
        // empty selection, but an explicit source_mapping.any.is_default rule must still win
        // over that fallback (matching fieldVisibilityRules.js, which has no equivalent
        // early-return) - so this can't short-circuit before the resolver runs
        const hasAnySourceMappingDefaultRule = Object.values(dim.source_mapping || {}).some(
            rule => typeof rule === 'object' && rule !== null && rule.hasOwnProperty('is_default')
        );

        // the source dimension itself defaults to selected once more than one source is chosen,
        // but only once source_mapping is actually in play for this field - this is specific to
        // is_default (there is no visibility equivalent), so it stays out of the shared resolver
        if (hasAnySourceMappingDefaultRule && dim.name === SOURCE_FIELD && rawSelectedSources?.length > 1) {
            return true;
        }

        return resolveSourceMapping(dim.source_mapping, rawSelectedSources, 'is_default', dim.is_default);
    },
    force: dim => {
        return dim.force_default;
    },
};
